/**
 * PipelineFlowIcon — Mi6 custom glyph: pipeline lane / funnel
 * viewBox 0 0 80 80, stroke 1.5px, currentColor
 */
export default function PipelineFlowIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <svg
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {/* Wide top lane */}
      <path d="M10 20 L70 20 L58 34 L22 34 Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      {/* Mid lane */}
      <path d="M22 36 L58 36 L50 48 L30 48 Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      {/* Narrow bottom lane */}
      <path d="M30 50 L50 50 L44 62 L36 62 Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      {/* Flow arrow stem */}
      <line x1="40" y1="62" x2="40" y2="68" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <polyline points="36,65 40,70 44,65" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      {/* Lane divider lines inside top tier */}
      <line x1="30" y1="20" x2="26" y2="34" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.45" />
      <line x1="50" y1="20" x2="54" y2="34" stroke="currentColor" strokeWidth="1" strokeLinecap="round" opacity="0.45" />
    </svg>
  );
}
